import scrollMonitor from 'scrollmonitor';
import '../helpers/arrayFromPolyfill.js';
import '../helpers/foreach.js';

/**
 * Navigation
 */

const sections = [...document.querySelectorAll('.js-section')];
const sectionLinks = [...document.querySelectorAll('.js-section-link')];
const navPointer = document.querySelector('.js-nav-pointer');

sections.forEach((section) => {
    // We need the id's to match the sections real id used with anchor tags so
    // as an work around we're targeting the id="comic-section" instead and
    // stripping the '-section' part.
    const id = section.id.replace('-section', '');
    const watcher = scrollMonitor.create(section, { top: -500, bottom: -500 });

    watcher.enterViewport(() => {
        sectionLinks.forEach((sectionLink) => {
            sectionLink.classList.remove('is-active');
        });

        sectionLinks
            .filter(sectionLink => sectionLink.href.split('#')[1] === id)
            .forEach((sectionLink) => {
                sectionLink.classList.add('is-active');
                const activeLink = document.querySelector('.js-section-link.is-active');
                const activeLinkOffset = activeLink.getAttribute('data-pointer-offset');
                navPointer.style.transform = `translateY(${activeLinkOffset}px)`;
            });
    });
});


/*
 * Mobile Nav
 */

const mobileNavButton = document.querySelector('.js-mobile-nav-button');
const mobileNavLinks = [...document.querySelectorAll('.js-mobile-nav-link')];
const mobileNavDrawer = document.querySelector('.js-mobile-nav-drawer');

function toggleActive() {
    mobileNavDrawer.classList.toggle('is-active');
    mobileNavButton.classList.toggle('is-active');
    document.body.classList.toggle('mobile-nav-active');
}

mobileNavButton.addEventListener('click', () => {
    toggleActive();
});

mobileNavDrawer.addEventListener('click', () => {
    toggleActive();
});

mobileNavLinks.forEach((link) => {
    link.addEventListener('click', toggleActive);
});




// WEBPACK FOOTER //
// ./src/js/features/nav.js